import { ConfigInterface, responseInterface } from 'swr';
import { parseUrl, useWPApi, wpApi } from '@gik/core/api';
import { ResponsePromise } from 'ky';
import { WordpressError } from '@gik/core/models/wordpress/WordpressError';
import { IWordpressGiftCardCategory } from '@gik/calendar/models/GiftCardCategory';

const path = 'gift-card-category';

function getParams() {
  return {
    _fields: ['id', 'name', 'acf.sort_order'],
  };
}

export function getGiftcardCategories(): ResponsePromise {
  const finalUrl = parseUrl(path, {
    searchParams: getParams(),
  });

  return wpApi.get(finalUrl);
}

export function useGiftcardCategories<Data = IWordpressGiftCardCategory[], Error = WordpressError>(
  config?: ConfigInterface
): responseInterface<Data, Error> {
  return useWPApi<Data, Error>(path, config, {
    searchParams: getParams(),
  });
}
